/**
 * Determines whether the project prefix/suffix fields should be disabled.
 *
 * Prefix/suffix are editable for both new and existing projects as long as the
 * user has write permission on the project, and the form is not in the
 * "convert to project" flow (converting a tender should not allow changing the
 * numbering scheme).
 *
 * Note: editing prefix/suffix on an existing project only affects PO/WO numbers
 * generated afterward; previously generated PO/WO numbers are left unchanged.
 *
 * @param {Object} params
 * @param {boolean} [params.writePermission] - Whether the user has write access to the project.
 * @param {boolean} [params.isConvertToProject] - Whether the form is in the convert-to-project flow.
 * @returns {boolean} True if the prefix/suffix fields should be disabled.
 */
export function isPrefixSuffixDisabled({ writePermission, isConvertToProject }) {
  return !writePermission || Boolean(isConvertToProject);
}
